// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ReviewCard_wrapper__OATuo","title":"ReviewCard_title__Nj3fq","body":"ReviewCard_body__lyQqV"};